import React from "react";

const VoterEducationSection = () => {
  return (
    <section
      className="relative bg-cover bg-center bg-no-repeat text-white"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1580790063313-160d5b16d2ed?auto=format&fit=crop&w=1470&q=80')",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-orange-50/60 via-black/70 to-green-600/60 z-0" />

      <div className="relative z-10 py-20 px-4 md:px-10">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl font-extrabold mb-4 text-white drop-shadow">
            🧠 <span className="text-yellow-300">Educating Every Voter</span> — गांव से संसद तक
          </h2>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto mb-6">
            समझिए वोटर अधिकार, देखिए उम्मीदवार का ट्रैक रिकॉर्ड, और बनाइए भारत को जवाबदेह।
            This platform empowers even the newest voter to make informed democratic decisions.
          </p>

          <ul className="text-left text-gray-100 list-disc list-inside space-y-2 max-w-2xl mx-auto">
            <li>✅ वोटर पंजीकरण कैसे करें (How to Register)</li>
            <li>🧾 MLA, MP, पंचायत क्या काम करते हैं</li>
            <li>📊 Track candidates' old issues and resolved promises</li>
            <li>📚 Stay informed with real verified political data</li>
          </ul>

          <div className="mt-10">
            <a
              href="/register"
              className="inline-block bg-gradient-to-r from-orange-500 to-green-600 text-white font-semibold px-6 py-3 rounded-full hover:scale-105 transition shadow-lg"
            >
              ✍️ Register & Raise Your Voice
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VoterEducationSection;
